import { DominioHttpGateway } from "../gateway/Dominio/DominioHttpGateway";

/** As chaves que a rota `empresa/chaves` aceita. A tela (`COMPANY_OPTIONS`) tem as mesmas, conferidas em teste. */
export const COMPANY_OPTION_KEYS = [
    "ignoreCustomersSuppliers",
    "ownEntriesOnly",
    "accountsWithoutMovement",
    "ledger"
];

const FALLBACK_MESSAGE =
    "Não deu para salvar as chaves agora. Tente de novo em instantes.";

/**
 * Muda as chaves do contábil de uma empresa do Domínio na NUCONT. Manda só as chaves que mudaram e devolve as
 * chaves como a NUCONT gravou. `ledger: false` apaga o razão guardado da empresa (LGPD).
 */
export class SetDominioCompanyOptionsUsecase {
    constructor() {
        this.DominioHttpGateway = new DominioHttpGateway();
    }

    async execute({ accountingId = "", companyId = "", change = {} } = {}) {
        const payload = this.sanitizeInput({ accountingId, companyId, change });
        if (
            !payload.accountingId ||
            !payload.companyId ||
            !Object.keys(payload.change).length
        )
            return null;

        let response;
        try {
            response = await this.DominioHttpGateway.setCompanyOptions(payload);
        } catch (error) {
            // Rede fora ou resposta que não é JSON (um 502 em HTML): o texto cru não fala com o escritório.
            throw new Error(FALLBACK_MESSAGE);
        }
        if (!response?.options)
            throw new Error(this.messageOf(response) || FALLBACK_MESSAGE);
        return response.options;
    }

    sanitizeInput({ accountingId = "", companyId = "", change = {} } = {}) {
        return {
            accountingId: String(accountingId || "").trim(),
            companyId: String(companyId || "").trim(),
            change: Object.fromEntries(
                COMPANY_OPTION_KEYS.filter(
                    (key) => typeof change?.[key] === "boolean"
                ).map((key) => [key, change[key]])
            )
        };
    }

    /**
     * A recusa da regra vem em `error` (sem permissão, código do Domínio em duas empresas, empresa não conectada) e
     * já fala com o escritório; a da entrada (400) vem solta, com `name` e `message` em português. A do login também
     * vem solta, mas sem `name` e em inglês: essa fica com a mensagem padrão.
     */
    messageOf(response) {
        if (response?.error?.message) return response.error.message;
        return response?.name ? response?.message || "" : "";
    }
}
